import React from 'react';
import './Contact.css';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

const Contact = () => {
  return (
    <section className="contact-section">
      <h2>Get in Touch</h2>
      <div className="info-cards">
        <div className="card">
          <div className="icon type-map"><FaMapMarkerAlt /></div>
          <h3>Marketing Office</h3>
          <p>Harrygen Labs Pvt. Ltd.<br />
          Natraj Road, Opp. DSB School, Rishikesh, Uttarakhand 249204</p>
        </div>
        <div className="card">
          <div className="icon type-email"><FaEnvelope /></div>
          <h3>Email</h3>
          <p>info@harrygenlabs.com</p>
        </div>
        <div className="card">
          <div className="icon type-phone"><FaPhoneAlt /></div>
          <h3>Phone</h3>
          <p>Coming Soon</p>
        </div>
      </div>

      <form
        className="contact-form"
        action="https://formspree.io/f/meozjozg"
        method="POST"
      >
        <h3>Send a Message</h3>
        <input type="text" name="name" placeholder="Your Name" required />
        <input type="email" name="email" placeholder="Your Email" required />
        <textarea name="message" placeholder="Your Message" required></textarea>
        <button type="submit">Submit</button>
      </form>

      <div className="map-container">
        <iframe
          title="Harrygen Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3432.3445470342497!2d78.2811356!3d30.0634484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39093e67cf93f111%3A0xcc78804a6f941bfe!2sNatraj%20Road%2C%20Rishikesh%2C%20Uttarakhand%20249201!5e0!3m2!1sen!2sin!4v1624455356785!5m2!1sen!2sin"
          width="100%" 
          height="280" 
          style={{ border: 0 }} 
          //allowFullScreen 
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;